<ng-container *ngIf="!fileUrl">
  <io-provetech-file-input class="w-full h-full" (selectedFile)="handleInputEvent($event)"></io-provetech-file-input>
</ng-container>
<ng-container *ngIf="fileUrl">
  <io-provetech-file-preview [fileUrl]="fileUrl" (clearEvent)="clear()"></io-provetech-file-preview>
</ng-container>
